import { render, staticRenderFns } from "./SoftwareStatus.vue?vue&type=template&id=fed168b8&"
import script from "./SoftwareStatus.vue?vue&type=script&lang=js&"
export * from "./SoftwareStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports